import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Services = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const services = [
    {
      id: 'commercial',
      title: 'Commercial Construction',
      description: 'Complete commercial construction services including office buildings, retail spaces, warehouses, and institutional facilities. We understand the unique requirements of commercial projects and deliver results that meet strict specifications and timelines.',
      icon: '🏢'
    },
    {
      id: 'residential',
      title: 'Residential Construction & Renovation',
      description: 'From custom homes to major renovations, we bring the same level of professionalism and quality to every residential project. Our attention to detail—along with experience navigating local permitting processes—ensures your home project exceeds expectations.',
      icon: '🏠'
    },
    {
      id: 'demolition',
      title: 'Demolition',
      description: 'We provide demolition services for a variety of projects. Our team is experienced in safely and efficiently removing structures and debris to ensure a clean and safe environment.',
      icon: '🚧'
    },
    {
      id: 'maintenance',
      title: 'Maintenance & Repair Services',
      description: 'Reliable ongoing maintenance and repair services for commercial and residential properties. We provide prompt response and quality solutions to keep your property in excellent condition.',
      icon: '🔧'
    },
    {
      id: 'project-management',
      title: 'Project Management',
      description: 'Comprehensive project management services ensuring seamless coordination of all trades, timelines, and deliverables. Our systematic approach minimizes disruptions and maximizes efficiency.',
      icon: '📋'
    },
    {
      id: 'government',
      title: 'Government Contracting',
      description: 'Specialized experience in federal, state, and local government contracting. We understand the unique requirements and compliance standards for government projects and deliver exceptional results.',
      icon: '🏛️'
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-title centered">
          <h2>Our Services</h2>
          <p>Comprehensive Construction Solutions</p>
        </div>

        <motion.div 
          className="services-grid"
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {services.map((service) => (
            <motion.div 
              key={service.id} 
              className="service-card"
              variants={itemVariants}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </motion.div>

        <div className="services-cta">
          <p>Looking for a specific service not listed here?</p>
          <a href="#contact" className="btn btn-primary">Contact Us</a>
        </div>
      </div>
    </section>
  );
};

export default Services;
